module.exports = __webpack_public_path__ + "img/iconAboutUs.aa608e41.svg";